import { createSlice } from '@reduxjs/toolkit';
import type { Editor } from '@tiptap/react';
import { useSelector } from 'react-redux';

import type { Coin } from 'interfaces/MeshMaven';

export interface Revision {
  originalState: Editor;
  updatedState: Editor;
  requestId: string;
  isAIFeedbackProvided: boolean;
  isReanalyzeEnabled: boolean;
  feedbackAnalysis: Coin;
}

type AddViolationInitialState = {
  type: string;
  severity: string;
  description?: string;
  descriptionHtml?: string;
  rephrasedDescription?: string;
  rephrasedDescriptionHtml?: string;
  status?: string;
  raisedFor?: {
    id: number;
    displayName: string;
  };
  raisedBy?: number;
  reportedTime?: Date;
  isSecondaryPanelOpen?: boolean;
  revisionNumber: number;
  revisions: Revision[];
  rephraseError?: string;
  analysisError?: string;
  meshMavenGroupId?: string;
  selectedRevision: Revision;
  isPastNotesPanelOpen: boolean;
  pastNotes: any[];
};

const initialState: AddViolationInitialState = {
  type: '',
  severity: 'Low',
  description: null,
  descriptionHtml: null,
  rephrasedDescription: null,
  rephrasedDescriptionHtml: null,
  status: null,
  reportedTime: new Date(),
  isSecondaryPanelOpen: false,
  revisionNumber: 0,
  revisions: [],
  rephraseError: null,
  analysisError: null,
  meshMavenGroupId: '',
  selectedRevision: null,
  isPastNotesPanelOpen: false,
  raisedFor: null,
  pastNotes: [],
};

const addViolationSlice = createSlice({
  name: 'addViolation',
  initialState,
  reducers: {
    initializeAddViolationDrawer: (state) => ({
      ...state,
      ...initialState,
    }),
    updateAddViolationDrawer: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      };
      newState.selectedRevision = newState.revisions[newState.revisionNumber];
      return newState;
    },
  },
});

export const { initializeAddViolationDrawer, updateAddViolationDrawer } = addViolationSlice.actions;
export default addViolationSlice.reducer;

export const useSelectAddViolationDrawerData = () =>
  useSelector((state: { addViolation: AddViolationInitialState }) => state.addViolation);
